import { DVTJCUVConnectCddEmpParentTabs } from "@pages/dvtjcuv/common/ConnectCddEmpTabs";
import ConnectCddEmpContent from "@pages/dvtjcuv/rundvtjcuv/connectcddemp/ConnectCddEmpContent";
import HeaderSearchButtons from "@pages/dvtjcuv/rundvtjcuv/HeaderSearchButtons";
import React, { useEffect, useState } from "react";
import { DVTJCUVPipelineBlock } from '@pages/dvtjcuv/common/Constant';


const ConnectCddEmpManager = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [currentParentTab, setCurrentParentTab] = useState(DVTJCUVConnectCddEmpParentTabs.PRIORITY_PROCESS_TAB);
    const [runJobInfo, setRunJobInfo] = useState({
        email_tab: {}
    });

    const {runJob} = props

    const hash = window.location.hash.substring(1);

    useEffect(() => {
        if (runJob) {
            setRunJobInfo({...runJob})
        }
    }, [runJob]);

    useEffect(() => {
        Object.values(DVTJCUVConnectCddEmpParentTabs).forEach(tab => {
            if (hash && hash === tab.id) {
                setCurrentParentTab(tab);
            }
        })
    }, []);


    const activeTab = (tab) => {
        if (currentParentTab.id === tab.id) {
            return 'active'
        }
        return ''
    }

    return (
        <div className="card card-default">
            <div className="card-header">
                <h3 className="card-title text-bold">CONNECT CDD EMP</h3>
                <button type="button" className="btn btn-tool" data-card-widget="collapse">
                    <i className="fas fa-minus"/>
                </button>
                <div className="card-tools pr-2">
                <HeaderSearchButtons
                    parentTabId={DVTJCUVPipelineBlock.ConnectCddEmpManager}
                    // no need to sub tab id => brief sent tab
                    // tabId={currentTab.id}
                    // showBtnSearchPipeline={parentOfTab.id !== DVTJCUVConnectCddEmpParentTabs.CALL_CHAT_DN_REC_UPD_INF.id}
                    // showBtnSearchCdd={parentOfTab.id !== DVTJCUVConnectCddEmpParentTabs.CALL_CHAT_DN_REC_UPD_INF.id}
                    showBtnSearchPipeline
                    showBtnSearchCdd
                    showBtnSearchReceiver
                    showBtnSearchEmployer
                />
                    {/*<Button type='button'*/}
                    {/*        className='btn btn-primary'*/}
                    {/*        isLoading={isLoading}*/}
                    {/*        disabled={isLoading}*/}
                    {/*        onClick={() => {*/}

                    {/*        }}*/}
                    {/*>*/}
                    {/*    /!*<i className='fas fa-save mr-2'/>*!/*/}
                    {/*    Nhập Cdd-GP-Emp Discussion*/}
                    {/*</Button>*/}
                </div>
            </div>
            <div className="card-body">
                <ul className='nav nav-tabs' role='tablist'>
                    {Object.values(DVTJCUVConnectCddEmpParentTabs).map(tab => (
                        <li className='nav-item' key={tab.id}>
                            <a className={`nav-link ${activeTab(tab)}`} data-toggle='tab' href={`#${tab.id}`}
                               onClick={() => {setCurrentParentTab(tab); window.location.hash = tab.id;}}>
                                {tab.title}
                            </a>
                        </li>
                    ))}
                </ul>
                <div className='tab-content'>
                    {Object.values(DVTJCUVConnectCddEmpParentTabs).map((tab, index) => {
                        if (currentParentTab.id === tab.id) {
                            return <div id={tab.id} className={`tab-pane active`}>
                                <ConnectCddEmpContent data={runJobInfo} parentTab={tab}/>
                            </div>
                        }
                        return ""
                    })}
                </div>
            </div>
        </div>
    )
}

export default ConnectCddEmpManager;
